import { Box, Grid, Typography, Button,InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ProfitLLossList from "./ProfitLossList";
import color from "../../../../constants/color"
import SubHeader from "../../../../components/SubHeader"
import {ReactComponent as Download}from "../../../../assets/ViewLeave-images/download.svg";

import dayjs from "dayjs";

const ProfitLLoss = ({data,getProfitLoss}) => {
  const [startDate, setStartDate] = useState(() => dayjs().startOf("month"))
  const [endDate, setEndDate] = useState(() => dayjs().endOf("month"))
  useEffect(() => {
    getProfitLoss(startDate,endDate)
  },[])

  return (
    <>
      <Box px="15px" pt="20px" display={{xs: "block", md:"flex"}} justifyContent="space-between" alignItems="center">
        <Typography variant="h5" sx={style.leaveHeading}>Profit and Loss Statement</Typography>

        <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }} mt={{xs:2, md: 0}}>
          <Button variant="contained" color="success" sx={style.csvBtns} ><Download />
            {"CSV"}
          </Button>

          <Button variant="contained" color="success" sx={style.checkinBtns} ><Download />
            {"Export PDF"}
          </Button>


        </Box>
      </Box>

      <Grid container spacing={2} px="15px">
        <Grid item md={7} xs={12}>
          <Box sx={style.dateCard}>
            <Box sx={style.inputBox}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <InputLabel sx={style.label}>Start Month</InputLabel>
                <DatePicker 
                  value={startDate}  
                  sx={style.dateInput}
                  maxDate={endDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  slotProps={{
                    field: {
                      readOnly: true
                    }
                  }} />
              </LocalizationProvider>
            </Box>
            <Box sx={style.inputBox}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <InputLabel sx={style.label}>End Month</InputLabel>
                <DatePicker 
                  value={endDate}  
                  sx={style.dateInput}
                  minDate={startDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  slotProps={{
                    field: {
                      readOnly: true
                    }
                  }} />
              </LocalizationProvider>

            </Box>
            <Box sx={{mt:3}}> 
              <Button variant="contained" onClick={() => getProfitLoss(startDate,endDate)} color="success" sx={style.checkinBtn} >
                {"Apply Filter"}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2} px="15px">
        <Grid item md={4} xs={12}>
          <Box sx={style.card}>
            <Box>
              <Typography sx={style.textHeading}>Gross Profit</Typography> <Typography sx={style.textBody}>$94403</Typography>
            </Box>
            <Box sx={style.percentageContainer}>
              <Typography sx={style.percentagetext}>26% <ExpandLessIcon sx={{ fontSize: "1rem" }} /></Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item md={4} xs={12}>
          <Box sx={style.card}>
            <Box>
              <Typography sx={style.textHeading}>Net Profit</Typography> <Typography sx={style.textBody}>$54403</Typography>
            </Box>
            <Box sx={style.percentageContainer}>
              <Typography sx={style.percentagetext}>26% <ExpandLessIcon sx={{ fontSize: "1rem" }} /></Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box sx={style.card}>
            <Box>
              <Typography sx={style.textHeading}>Average Profit & Loss </Typography> <Typography sx={style.textBody}>$-3002</Typography>
            </Box>
            <Box sx={style.percentageContainers}>
              <Typography sx={style.percentagetexts}>26%<ExpandMoreIcon sx={{ fontSize: "1rem" }} /></Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={false}
          search
          sortBy
        />
        <ProfitLLossList data={data} />
    

      </Box>

    </>
  )
}

export default ProfitLLoss;